// Wrapper for failsafe usage of dataLayer
// Use like this:
// import {dataLayer} from 'shared'
// dataLayer.push(...)

export const dataLayer = {
  push: args => window?.['dataLayer']?.push?.(args)
}
